import React, { lazy } from 'react';
import Loadable from "app/components/Loadable";
import { authRoles } from '../../../auth/authRoles'
const Dashboard = Loadable(lazy(() => import('./Dashboard')))
const ProCoreAuthCallback = Loadable(lazy(() => import('../sites/ProCore/ProCoreAuthCallBack')))
const ProcoreError = Loadable(lazy(() => import('../sites/ProCore/ProCoreAuthError')))


const dashboardRoutes = [
    {
        path: '/',
        element: <Dashboard />,
        auth: authRoles.user,
    },
    {
        path: '/dashboard',
        element: <Dashboard />,
        auth: authRoles.user,
    },
    {
        path: 'callback',
        element: <ProCoreAuthCallback />
    },
    {
        path: 'error',
        element: <ProcoreError />
    }
]

export default dashboardRoutes
